import {ICurrentUavInfo, IUserInfo} from '@/types/baseInterFace'
/**
 * 持久化数据，该模块里面的数据会被持久化到sessionStorage中
 */
export default {
    namespaced: true,
    state: {
        currentUavInfo: {
            //被选中的机型信息
            uavId: null,
            nestId: null,
            trainingId: null,// 训练id
            flyTime: 0, //最大飞行时间
            maxZoom: 0,  //最大变焦倍数
            heightLimit: 0,//最大高度限制
            parentName:"",
            sceneImageUrl:"",
            sceneInfo:null,
            windSpeedIndex:0,
            windDirectionIndex:0,
            maxHolderPitch: 0, //最大俯仰角
            minHolderPitch:0, //最小俯仰角
            resourceFileList:[] as any
        },
        userInfo: {
            //用户信息
            userId: null,
            userName: '',
            name:null,
            appId:null,
            phoneNum: ''
        },
        stationId: null,
        currentTenantId: null,
        examWindDirection: 0,               //考试风向
        breadcrumb:[
            {currentPage:1,path:'/scene',name:'主页',active:true,id:null,courseTypeId:null},
        ],
        userTrainSettingInfo:{
            uavSpId:null,                   //无人机型号ID
            resourceTypeId:null,            //资源类型ID
            windDirection:null,             //风向
            windPower:null,                 //风速
            sightHeight:null,               //视高
            sightDist:null,                 //视距
            sightFov:null,                  //视宽
            changeFovDist:null,             //感距
            lightDirection:null,            //光照
            supportViewport:false,          //辅助视口
            shadowEnable:false,             //阴影显示
            enableGuide:true,               //引导开关
            currentStationId:null,          //当前站点ID
            distance:null,                  //距离
            usedTemplateId:null,            //用户应用的模板ID
            joystickSpecification:null,    //遥控器型号
            guideLineIds:null,              //航线ID
        },
        currentResourceTypeId:null,         //当前资源类型ID
        sounds:{
            droneSound: 0.3,                 //无人机声音
            humanSound: 0.3,                 //语音
            otherSound: 0.3,                 //其他声音（点击声音）
        },
        resolution: null,                    // User display resolution
        useNewEngineUrl: false,               // Enable the VK2 engine URL
        engineVersion: '',                    // Engine version returned by the API
        keyboard:{
            reset:'',
            switchGuid:'',
            switchView:'',
            homing:'',
            enlarge:'',
            reduce:'',
            shoot:''
        },
        towerIdentify:{
            sceneCategoryId:null,
            sceneTypeId:null,
            sceneInfo:null,
            airlineDetail:null,
            deviceDetail:null,
            title:null
        },
        carouselSelection:{
            thirdSceneCardId:null,
            towerCardId:null
        },
        enableCloudStorage:null,
    },

    mutations: {
        setCurrentUavInfo(state:{currentUavInfo:ICurrentUavInfo}, currentUavInfo:ICurrentUavInfo):void{
            const { uavId, nestId, trainingId, flyTime, maxZoom, heightLimit, parentName, sceneImageUrl, sceneInfo,windSpeedIndex,windDirectionIndex,
                maxHolderPitch, minHolderPitch,resourceFileList} = currentUavInfo || {};
            state.currentUavInfo.uavId = uavId;
            state.currentUavInfo.nestId = nestId;
            state.currentUavInfo.trainingId = trainingId;
            state.currentUavInfo.flyTime = flyTime;
            state.currentUavInfo.maxZoom = maxZoom;
            state.currentUavInfo.heightLimit = heightLimit;
            state.currentUavInfo.parentName = parentName;
            state.currentUavInfo.sceneImageUrl = sceneImageUrl;
            state.currentUavInfo.sceneInfo = sceneInfo;
            state.currentUavInfo.windSpeedIndex = windSpeedIndex;
            state.currentUavInfo.windDirectionIndex = windDirectionIndex;
            state.currentUavInfo.maxHolderPitch = maxHolderPitch;
            state.currentUavInfo.minHolderPitch = minHolderPitch;
            state.currentUavInfo.resourceFileList = resourceFileList;
        },
        clearCurrentUavInfo(state:any):void{
            state.currentUavInfo.uavId = null;
            state.currentUavInfo.nestId = null;
            state.currentUavInfo.trainingId = null;
            state.currentUavInfo.flyTime = 0;
            state.currentUavInfo.maxZoom = 0;
            state.currentUavInfo.heightLimit = 0;
            state.currentUavInfo.parentName = "";
            state.currentUavInfo.sceneImageUrl = "";
            state.currentUavInfo.sceneInfo = null;
            state.currentUavInfo.windSpeedIndex = 0;
            state.currentUavInfo.windDirectionIndex = 0;
            state.currentUavInfo.maxHolderPitch = 0;
            state.currentUavInfo.minHolderPitch = 0;
            state.currentUavInfo.resourceFileList = [];
        },

        setUserInfo(state:any, userInfo:IUserInfo):void{
            const { userId, userName,name, appId, phoneNum } = userInfo || {};
            state.userInfo.userId = userId;
            state.userInfo.userName = userName;
            state.userInfo.name = name;
            state.userInfo.appId = appId;
            state.userInfo.phoneNum = phoneNum;
        },

        setStationId(state:any, stationId:number | string | null) {
            state.stationId = stationId;
        },
        setCurrentTenantId(state:any, currentTenantId:number | string | null) {
            state.currentTenantId = currentTenantId;
        },
        setExamWindDirection(state:{examWindDirection:number | string | null}, examWindDirection:number | string | null):void {
            state.examWindDirection = examWindDirection;
        },

        setBreadcrumb(state:any, breadcrumb:Array<any>){
            state.breadcrumb = breadcrumb;
        },

        setUserTrainingSetting(state:any, userTrainingSetting:any){
            const {uavSpId, resourceTypeId, windDirection, windPower, sightHeight, sightDist, sightFov, changeFovDist, lightDirection, supportViewport,shadowEnable,currentStationId,distance,usedTemplateId,joystickSpecification,guideLineIds,enableGuide} = userTrainingSetting || {};
            state.userTrainSettingInfo.uavSpId = uavSpId;
            state.userTrainSettingInfo.resourceTypeId = resourceTypeId;
            state.userTrainSettingInfo.windDirection = windDirection;
            state.userTrainSettingInfo.windPower = windPower;
            state.userTrainSettingInfo.sightHeight = sightHeight;
            state.userTrainSettingInfo.sightDist = sightDist;
            state.userTrainSettingInfo.sightFov = sightFov;
            state.userTrainSettingInfo.changeFovDist = changeFovDist;
            state.userTrainSettingInfo.lightDirection = lightDirection;
            state.userTrainSettingInfo.supportViewport = supportViewport;
            state.userTrainSettingInfo.shadowEnable = shadowEnable;
            state.userTrainSettingInfo.enableGuide = enableGuide;
            state.userTrainSettingInfo.currentStationId = currentStationId;
            state.userTrainSettingInfo.distance = distance;
            state.userTrainSettingInfo.usedTemplateId = usedTemplateId;
            state.userTrainSettingInfo.joystickSpecification = joystickSpecification;
            state.userTrainSettingInfo.guideLineIds = guideLineIds;
        },
        setCurrentResourceId(state:any, resourceId:number | string | null) { 
            state.currentResourceTypeId = resourceId;
        },
        setSounds(state:any, sounds:any){
            const {droneSound, humanSound, otherSound} = sounds || {};
            state.sounds.droneSound = droneSound / 100;
            state.sounds.humanSound = humanSound / 100;
            state.sounds.otherSound = otherSound / 100;
        },
        setResolution(state:any, resolution:string | null){
            state.resolution = resolution;
        },
        setUseNewEngineUrl(state:{useNewEngineUrl:boolean}, useNewEngineUrl:boolean):void{
            state.useNewEngineUrl = useNewEngineUrl;
        },
        setEngineVersion(state:{engineVersion:string}, engineVersion:string):void{
            state.engineVersion = engineVersion;
        },
        setKeyboard(state:any, keyboard:any){
            const {reset,switchGuid,switchView,homing,enlarge,reduce,shoot} = keyboard || {};
            state.keyboard.reset = reset;
            state.keyboard.switchGuid = switchGuid;
            state.keyboard.switchView = switchView;
            state.keyboard.homing = homing;
            state.keyboard.enlarge = enlarge;
            state.keyboard.reduce = reduce;
            state.keyboard.shoot = shoot;
        },
        setTowerIdentify(state:any, towerIdentify:any){
            const {sceneCategoryId, sceneTypeId, sceneInfo, airlineDetail, deviceDetail, title} = towerIdentify || {};
            state.towerIdentify.sceneCategoryId = sceneCategoryId;
            state.towerIdentify.sceneTypeId = sceneTypeId;
            state.towerIdentify.sceneInfo = sceneInfo;
            state.towerIdentify.airlineDetail = airlineDetail;
            state.towerIdentify.deviceDetail = deviceDetail;
            state.towerIdentify.title = title;
        },
        setCarouselSelection(state:any, selection:any){
            const payload = selection || {};
            if (Object.prototype.hasOwnProperty.call(payload, 'thirdSceneCardId')) {
                state.carouselSelection.thirdSceneCardId = payload.thirdSceneCardId;
            }
            if (Object.prototype.hasOwnProperty.call(payload, 'towerCardId')) {
                state.carouselSelection.towerCardId = payload.towerCardId;
            }
        },
        setEnableCloudStorage(state:any, enableCloudStorage:any){
            state.enableCloudStorage = enableCloudStorage
        }
    },

    actions: {

    },

    getters: {

    }
};
